import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full pt-16">
      <div className="relative w-full overflow-hidden rounded-b-[2.5rem]">
        <div className="absolute inset-0">
          <img
            src="https://readdy.ai/api/search-image?query=Dramatic%20dark%20cinematic%20entertainment%20news%20background%20with%20red%20and%20gold%20accents%20paparazzi%20flash%20lights%20effect%20mysterious%20atmosphere%20abstract%20composition%20with%20warm%20spotlight%20beams%20and%20dark%20shadows%20luxury%20magazine%20editorial%20vibe%20with%20theatrical%20drama&width=1600&height=700&seq=hero-bg-2026&orientation=landscape"
            alt="51爆料网 - 每日爆料追踪"
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/50"></div>
        </div>

        <div className="relative z-10 w-full max-w-[1400px] mx-auto px-4 md:px-6">
          <div className="flex flex-col lg:flex-row items-start gap-8 py-16 md:py-24">
            <div className="lg:w-1/2">
              <h1 className="text-4xl md:text-6xl lg:text-7xl font-heading font-bold text-background-50 leading-[1.05] tracking-tight">
                <span className="block">全网吃瓜</span>
                <span className="block text-primary-400">一手黑料</span>
              </h1>
            </div>

            <div className="lg:w-1/2 flex flex-col justify-end pt-2 lg:pt-6">
              <p className="text-background-100/80 text-base md:text-lg leading-relaxed mb-4 max-w-md">
                每日实时追踪网红明星最新黑料，独家揭秘娱乐圈不为人知的内幕。吃瓜群众的终极聚集地。
              </p>
              <Link
                to="/category/all"
                className="inline-flex items-center gap-2 text-background-50 text-sm font-medium hover:text-primary-300 transition-colors cursor-pointer group"
              >
                查看今日爆款
                <span className="w-5 h-5 flex items-center justify-center group-hover:translate-x-1 transition-transform">
                  <i className="ri-arrow-right-line"></i>
                </span>
              </Link>
            </div>
          </div>

          <div className="pb-8 md:pb-12">
            <div className="relative w-full h-[320px] md:h-[420px] rounded-2xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Magazine%20style%20editorial%20collage%20of%20entertainment%20news%20headlines%20with%20dramatic%20red%20and%20black%20color%20scheme%20breaking%20news%20aesthetic%20with%20bold%20typography%20overlay%20cinematic%20newspaper%20front%20page%20design%20concept%20modern%20tabloid%20style&width=1400&height=500&seq=hero-main-image&orientation=landscape"
                alt="51爆料每日大赛精选"
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent"></div>
              <div className="absolute bottom-6 left-6 right-6">
                <span className="inline-block px-3 py-1 bg-primary-500 text-background-50 text-xs font-semibold rounded-full mb-2">
                  今日头条
                </span>
                <h2 className="text-xl md:text-3xl font-heading font-bold text-background-50">
                  顶流男星深夜密会网红，酒店监控视频独家曝光
                </h2>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}